// Imports
import React from "react";
//Imports Helpers
import staticData from '../../../contexts/staticData.json';
import { formatCurrency } from "../../../shared/helpers";
//Import CSS
import './salaryExpenseDetailModal.css';

function SalaryExpenseDetailModal({ pme, onClose }) {
    const renderActivityTable = (activityId, activityData) => {
        const pmeActivity = pme.activities.find(act => act.id === activityId);

        return (
            <article key={activityId} className="activity-expense-table flex">
                <p>{pmeActivity?.nameOfAction || 'Actividad sin nombre'}</p>
                <section className='table-container'>
                    <table>
                        <thead>
                            <tr>
                                <th>Código</th>
                                <th>Nombre Categoría</th>
                                {['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                                    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'].map(mes => (
                                        <th key={mes}>{mes}</th>
                                    ))}
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {staticData.categoryExpensesRemunerations.map(category => (
                                <tr key={category.code}>
                                    <td>{category.code}</td>
                                    <td>{category.name}</td>
                                    {[...Array(12)].map((_, month) => {
                                        const monthValue = activityData.monthlyDistribution?.[month + 1]?.[category.code] || 0;
                                        return (
                                            <td 
                                                key={month}
                                                data-month={['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                                                    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'][month]}
                                            >
                                                {formatCurrency(monthValue)}
                                            </td>
                                        );
                                    })}
                                    <td>
                                        {formatCurrency(
                                            [...Array(12)]
                                                .reduce((sum, _, month) =>
                                                    sum + (activityData.monthlyDistribution?.[month + 1]?.[category.code] || 0),
                                                    0)
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan="2">TOTALES</td>
                                {[...Array(12)].map((_, month) => (
                                    <td key={month}>
                                        {formatCurrency(
                                            staticData.categoryExpensesRemunerations.reduce((sum, category) =>
                                                sum + (activityData.monthlyDistribution?.[month + 1]?.[category.code] || 0),
                                                0
                                            )
                                        )}
                                    </td>
                                ))}
                                <td>
                                    {formatCurrency(
                                        staticData.categoryExpensesRemunerations.reduce((totalSum, category) =>
                                            totalSum + [...Array(12)].reduce((monthSum, _, month) =>
                                                monthSum + (activityData.monthlyDistribution?.[month + 1]?.[category.code] || 0),
                                                0
                                            ),
                                            0
                                        )
                                    )}
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </section>
            </article>
        );
    };

    // Verificar si hay datos de gastos de remuneración
    const hasSalaryData = pme.salaryExpense && Object.keys(pme.salaryExpense).length > 0;

    return (
        <section className='salary-details-container flex'>
            <article className='modal-header flex'>
                <h3>Detalle Completo de Gastos de Remuneración PME {pme.yearPME}</h3>
                <button
                    className='button-close'
                    onClick={(e) => {
                        e.preventDefault();
                        onClose(false);
                    }}
                >
                    <p>Cerrar</p>
                </button>
            </article>
            <article className='modal-body flex'>
                {hasSalaryData ? (
                    Object.entries(pme.salaryExpense).map(([activityId, activityData]) =>
                        renderActivityTable(activityId, activityData)
                    )
                ) : (
                    <p className='message-not-found flex'>
                        No hay gastos de remuneración ingresados para este PME
                    </p>
                )}
            </article>
        </section>
    );
};

export default SalaryExpenseDetailModal;